export default "__VITE_ASSET__DDHoYb2k__"